import { IRequest } from './types.ts';
import { SERVER_TYPE, DEBUG_ENV, DEFAULT_ANTI_SPIDER } from '@/constants/index.ts';
import sdkInit, { provider } from './init/index.ts';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';
import logUtils from '@/utils/logUtils.ts';
import metricReporter from '@/utils/metricReporter.ts';

export class AntiSpiderPayManager {
  private static instance: AntiSpiderPayManager;
  private server_type: keyof typeof SERVER_TYPE.production = 'central'; //数据中心
  private env: keyof typeof DEBUG_ENV = 'production'; //环境
  private site_from: string = '' //站点
  private sdks: string[] = ['forter', 'cybersource', 'riskified'] //sdk
  private limit_init_pay_count: number = 1 //限制初始化最大次数
  private constructor() { }
  public init(params: IRequest) {
    window.__limit_init_pay_count = (window.__limit_init_pay_count || 0) + 1;
    this.server_type = params?.server_type || this.server_type;
    this.env = params?.env || this.env;
    this.site_from = params?.site_from || this.site_from;
    this.sdks = params?.sdks || this.sdks;
    GlobalVariables.set(GLOBAL_VARIABLES.ENV, this.env);
    let store_data: any = params?.data || DEFAULT_ANTI_SPIDER;
    this.initLog(params?.parentReport);
    this.initXHRAndFetch();
    this.loadScripts(store_data);
  }

  private initLog(parent: any) {
    metricReporter.setMetricFunction(parent);
  }

  private initXHRAndFetch() {
    if (window.__limit_init_pay_count > this.limit_init_pay_count) {
      logUtils.info('Initialization pay limit reached', `Current: ${window.__limit_init_pay_count}  Max: ${this.limit_init_pay_count} Please check for repeated initializations.`);
      return;
    };
  }

  private async loadScripts(data: any) {
    const needLoadSDK = {} as typeof import('@/constants')['DEFAULT_ANTI_SPIDER']
    if (Array.isArray(this.sdks) && this.sdks.length > 0) {
      this.sdks.forEach((sdk: string) => {
        if (data[sdk]) {
          needLoadSDK[sdk] = data[sdk]
        }
      })
    }
    sdkInit(needLoadSDK, { server_type: this.server_type, env: this.env, site_from: this.site_from });
  }

  public antiCybersource() {
    return provider.antiCybersource()
  }

  public antiForter() {
    return provider.antiForter()
  }

  public antiForterSiteId() {
    return provider.antiForterSiteId()
  }

  public antiRiskified() {
    return provider.antiRiskified()
  }

  public antiPayGroup() {
    //  提供基础数据，blackbox数据由宿主包提供
    return {
      forterDeviceFingerprintID: this.antiForter(),
      forterSiteId: this.antiForterSiteId(),
      riskifiedDeviceFingerprintID: this.antiRiskified(),
      deviceFingerId: this.antiCybersource(),
      blackbox: ''
    }
  }

  public static getInstance() {
    if (!AntiSpiderPayManager.instance) {
      AntiSpiderPayManager.instance = new AntiSpiderPayManager();
    }
    return AntiSpiderPayManager.instance;
  }
}

export default AntiSpiderPayManager.getInstance();
const antiCybersource = AntiSpiderPayManager.getInstance().antiCybersource.bind(AntiSpiderPayManager.getInstance());
const antiForter = AntiSpiderPayManager.getInstance().antiForter.bind(AntiSpiderPayManager.getInstance());
const antiForterSiteId = AntiSpiderPayManager.getInstance().antiForterSiteId.bind(AntiSpiderPayManager.getInstance());
const antiRiskified = AntiSpiderPayManager.getInstance().antiRiskified.bind(AntiSpiderPayManager.getInstance());
const antiPayGroup = AntiSpiderPayManager.getInstance().antiPayGroup.bind(AntiSpiderPayManager.getInstance());

export {
  antiCybersource,
  antiForter,
  antiForterSiteId,
  antiRiskified,
  antiPayGroup,
}
